import Button from '@mui/material/Button';

import Error from './component/Error';

function ChunkLoadErrorView() {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Error
      title="App Update Available"
      description="This application has recently been updated. Please refresh your browser. If the issue persists, clear your cache and try again."
      actions={
        <Button variant="contained" color="primary" onClick={handleRefresh}>
          Refresh
        </Button>
      }
    />
  );
}

export default ChunkLoadErrorView;
